import { WithdrawDetailsType } from "app/types/cryptoType";
import { UserType } from "app/types/userType";
import React, { ChangeEventHandler, Component, MouseEventHandler } from "react";
import { FormattedMessage } from "react-intl";
import "./CryptoFundingWithdrawNew.scss";
type Props = {
  user: UserType;
  withdrawDetails: WithdrawDetailsType;
  currency: string;
  requestWithdraw: MouseEventHandler;
  cancelWithdraw: MouseEventHandler;
  onChangeAddress: ChangeEventHandler;
  withdrawError: string;
};

class CryptoFundingWithdrawNew extends Component<Props> {
  render() {
    const {
      user,
      withdrawDetails,
      currency,
      requestWithdraw,
      cancelWithdraw,
      onChangeAddress,
      withdrawError,
    } = this.props;

    return (
      <React.Fragment>
        <div className="crypto-funding-withdraw-new__amount">
          <div className="crypto-funding-withdraw-new__title">
            <FormattedMessage id="cashier-withdrawal-details" />
          </div>
          <div>
            <FormattedMessage id="cashier-amount" />
            {`(${user["currencyCode"]}): `}
            {withdrawDetails.amountSending}
          </div>
          <div>
            <FormattedMessage id="cashier-amount" />
            {`(${currency.replace(/_/g, "-")}): `}
            {withdrawDetails.receiveQuantity}
          </div>
        </div>
        <div className="crypto-funding-withdraw-new__bottom-section">
          <div className="crypto-funding-withdraw-new__address-info">
            <div className="crypto-funding-withdraw-new__title">
              <FormattedMessage id="cashier-enter-wallet-address" />
            </div>
            <input type="text" onChange={onChangeAddress} />
            <div className="error-msg">{withdrawError}</div>
          </div>
          <div className="crypto-funding-withdraw-new__buttons-section">
            <div className="crypto-funding-withdraw-new__buttons-section__buttons">
              <button onClick={requestWithdraw}>
                <FormattedMessage
                  tagName="span"
                  id="cashier-request-withdrawal"
                />
              </button>
              <button className="error-button" onClick={cancelWithdraw}>
                <FormattedMessage tagName="span" id="button-cancel" />
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CryptoFundingWithdrawNew;
